var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85622 3.42815H4.57178V1.14371C4.57178 0.826669 4.31696 0.571854 3.99993 0.571854C3.68289 0.571854 3.42807 0.826669 3.42807 1.14371V3.42815H1.14363C0.826592 3.42815 0.571777 3.68296 0.571777 4C0.571777 4.31704 0.826592 4.57185 1.14363 4.57185H3.42807V6.8563C3.42807 7.17334 3.68289 7.42815 3.99993 7.42815C4.31696 7.42815 4.57178 7.17334 4.57178 6.8563V4.57185H6.85622C7.17326 4.57185 7.42807 4.31704 7.42807 4C7.42807 3.68296 7.17326 3.42815 6.85622 3.42815Z",
    fill: "#1C1C1C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.d37a054d9ef39174f6b6c816e8d5b005.svg";
export { ForwardRef as ReactComponent };